export interface AppData {
  id: string;
  title: string;
  description: string;
  phoneImage?: string;
  privacyPolicyUrl: string;
  termsOfServiceUrl: string;
  gradientFrom?: string;
  gradientTo?: string;
  appStoreUrl?: string;
}

import chess_clockImg from "./images/chess-clock.png";

import zmanImg from "./images/zman.png";
import noorImg from "./images/noor.png";
export const apps: AppData[] = [
{
    id: "chess-clock",
    title: "Turn Clock",
    description: "Track time and score with elegance. Preset or custom time controls, tap-to-start options, and dark mode—everything you need, nothing you don't.",
    phoneImage: chess_clockImg,
    privacyPolicyUrl: "/chess-clock/PrivacyPolicy.html",
    termsOfServiceUrl: "/chess-clock/TermsAndConditions.html",
    gradientFrom: "#DAD7CD",
    gradientTo: "#8B9A7D",
    appStoreUrl: "https://apps.apple.com/us/app/turnclock-simple-chess-clock/id6758020974"
  },
  {
    id: "zman",
    title: "Zman - Torah Times",
    description: "Track halachic times with precision. Know exactly when Shabbat begins, when your fast ends, and never miss a zman again. Simple, beautiful, location-aware.",
    phoneImage: zmanImg,
    privacyPolicyUrl: "/zman/PrivacyPolicy.html",
    termsOfServiceUrl: "/zman/TermsAndConditions.html",
    gradientFrom: "#DAD7CD",
    gradientTo: "#8B9A7D",
    appStoreUrl: "https://apps.apple.com/us/app/zman-torah-times/id6758142581"
  },
  {
    id: "noor",
    title: "Noor - Quran & Ramadan Times",
    description: "Ramadan Mubarak! Track your fasts with precision timing. Suhoor & Iftar times calculated for your exact location. May your worship be accepted.",
    phoneImage: noorImg,
    privacyPolicyUrl: "/noor/PrivacyPolicy.html",
    termsOfServiceUrl: "/noor/TermsAndConditions.html",
    gradientFrom: "#DAD7CD",
    gradientTo: "#8B9A7D",
    appStoreUrl: "https://apps.apple.com/app/noor-quran-ramadan-times/id6758161368"
  }
];
